import { createContext } from "react";

import type { OrganizationWebhookConfigData } from "../hooks/useOrganizationWebhookConfig";

/**
 * The organization's webhook endpoint state, instantiated once by `OrganizationWebhooksProvider`. Lives in
 * its own module (not next to the provider) so the provider file exports a component only — Fast Refresh
 * needs that — the same split `AccessDataContext` / `AccessDataProvider` use.
 */
export const OrganizationWebhooksContext = createContext<OrganizationWebhookConfigData | null>(null);
